import { createFileRoute } from '@tanstack/react-router';

import { EliminacionDatosPage } from '@/pages/eliminacion-datos';

export const Route = createFileRoute('/_public/eliminacion-datos')({
  component: EliminacionDatosPage,
});
